var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 48,
    viewBox: "0 0 164 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.035 48H6.04211C2.71205 48 0 45.2948 0 42V6C0 2.69327 2.71205 0 6.04211 0H157.035C160.362 0 163.077 2.69327 163.077 6V42C163.077 45.2948 160.362 48 157.035 48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.035 0.960598C159.828 0.960598 162.114 3.22594 162.114 6V42C162.114 44.7741 159.843 47.0394 157.035 47.0394H6.04211C3.24906 47.0394 0.963017 44.7741 0.963017 42V6C0.963017 3.22594 3.23406 0.960598 6.04211 0.960598C6.04211 0.960598 157.035 0.960598 157.035 0.960598ZM157.035 0H6.04211C2.71205 0 0 2.70524 0 6V42C0 45.3067 2.71205 48 6.04211 48H157.035C160.362 48 163.077 45.3067 163.077 42V6C163.077 2.70524 160.362 0 157.035 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9095 15.8783C84.8205 15.8783 83.9025 15.4982 83.1765 14.7501C82.4565 14.0229 82.0545 13.0204 82.0725 11.997C82.0725 10.9047 82.4445 9.98 83.1765 9.24683C83.8995 8.4987 84.8175 8.11865 85.9065 8.11865C86.9836 8.11865 87.9016 8.4987 88.6396 9.24683C89.3716 10.0039 89.7436 10.9286 89.7436 11.997C89.7316 13.0922 89.3596 14.0169 88.6396 14.7471C87.9166 15.5012 86.9986 15.8783 85.9095 15.8783ZM53.506 15.8783C52.4409 15.8783 51.5169 15.5042 50.7609 14.765C50.0109 14.0289 49.6299 13.0982 49.6299 11.9999C49.6299 10.9017 50.0109 9.97102 50.7609 9.23486C51.5019 8.49571 52.4259 8.12165 53.506 8.12165C54.034 8.12165 54.547 8.22638 55.039 8.43885C55.522 8.64534 55.915 8.92663 56.206 9.27077L56.278 9.35756L55.465 10.1536L55.381 10.0548C54.922 9.51017 54.307 9.24384 53.494 9.24384C52.7679 9.24384 52.1349 9.5012 51.6129 10.0099C51.0879 10.5216 50.8209 11.192 50.8209 12.0029C50.8209 12.8139 51.0879 13.4842 51.6129 13.996C52.1349 14.5047 52.7679 14.762 53.494 14.762C54.268 14.762 54.919 14.5047 55.426 13.996C55.726 13.6967 55.912 13.2778 55.978 12.7481H53.3709V11.6289H57.097L57.112 11.7306C57.139 11.9192 57.166 12.1137 57.166 12.2932C57.166 13.3256 56.854 14.1605 56.236 14.777C55.534 15.5072 54.616 15.8783 53.506 15.8783ZM96.5897 15.7196H95.4407L91.9216 10.1027L91.9516 11.1142V15.7167H90.8026V8.28025H92.1136L92.1497 8.33711L95.4587 13.6279L95.4287 12.6194V8.28025H96.5897V15.7196V15.7196ZM77.2754 15.7196H76.1114V9.39945H74.0923V8.28025H79.2914V9.39945H77.2724V15.7196H77.2754ZM73.1443 15.7196H71.9833V8.28025H73.1443V15.7196ZM66.6192 15.7196H65.4582V9.39945H63.4391V8.28025H68.6382V9.39945H66.6192V15.7196ZM62.7041 15.7077H58.252V8.28025H62.7041V9.39945H59.4161V11.4403H62.3831V12.5476H59.4161V14.5885H62.7041V15.7077ZM84.0285 13.981C84.5475 14.4987 85.1775 14.759 85.9095 14.759C86.6626 14.759 87.2776 14.5047 87.7906 13.981C88.3006 13.4723 88.5586 12.8049 88.5586 11.9999C88.5586 11.195 88.3006 10.5246 87.7936 10.0189C87.2746 9.5012 86.6415 9.24085 85.9125 9.24085C85.1595 9.24085 84.5445 9.49521 84.0345 10.0189C83.5245 10.5276 83.2665 11.195 83.2665 11.9999C83.2665 12.8049 83.5215 13.4753 84.0285 13.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9639 26.1068C79.1289 26.1068 76.8309 28.2524 76.8309 31.212C76.8309 34.1447 79.1439 36.3173 81.9639 36.3173C84.799 36.3173 87.097 34.1567 87.097 31.212C87.097 28.2524 84.799 26.1068 81.9639 26.1068ZM81.9639 34.2943C80.4129 34.2943 79.0779 33.0135 79.0779 31.2001C79.0779 29.3597 80.4159 28.1058 81.9639 28.1058C83.515 28.1058 84.85 29.3597 84.85 31.2001C84.853 33.0255 83.515 34.2943 81.9639 34.2943ZM70.7647 26.1068C67.9297 26.1068 65.6317 28.2524 65.6317 31.212C65.6317 34.1447 67.9447 36.3173 70.7647 36.3173C73.5998 36.3173 75.8978 34.1567 75.8978 31.212C75.8978 28.2524 73.5968 26.1068 70.7647 26.1068ZM70.7647 34.2943C69.2137 34.2943 67.8787 33.0135 67.8787 31.2001C67.8787 29.3597 69.2167 28.1058 70.7647 28.1058C72.3158 28.1058 73.6508 29.3597 73.6508 31.2001C73.6508 33.0255 72.3158 34.2943 70.7647 34.2943ZM57.4385 27.6659V29.8265H62.6376C62.4786 31.0385 62.0766 31.9332 61.4616 32.5467C60.6996 33.3068 59.5235 34.1327 57.4505 34.1327C54.2555 34.1327 51.7564 31.5592 51.7564 28.3721C51.7564 25.1851 54.2555 22.6115 57.4505 22.6115C59.1755 22.6115 60.4326 23.2908 61.3656 24.1587L62.9016 22.6265C61.6056 21.3876 59.8806 20.439 57.4625 20.439C53.0794 20.439 49.4014 24.0001 49.4014 28.3602C49.4014 32.7322 53.0764 36.2814 57.4625 36.2814C59.8296 36.2814 61.6056 35.5093 63.0096 34.0549C64.4406 32.6275 64.8936 30.6135 64.8936 28.9886C64.8936 28.4829 64.8546 28.028 64.7736 27.642H57.4355C57.4385 27.639 57.4385 27.6659 57.4385 27.6659ZM111.946 29.3477C111.517 28.2016 110.221 26.0948 107.563 26.0948C104.929 26.0948 102.739 28.1627 102.739 31.2001C102.739 34.0669 104.905 36.3053 107.818 36.3053C110.158 36.3053 111.52 34.8779 112.081 34.04L110.344 32.8789C109.768 33.7317 108.967 34.2913 107.83 34.2913C106.681 34.2913 105.877 33.7706 105.343 32.7442L112.186 29.9163C112.186 29.9193 111.946 29.3477 111.946 29.3477ZM104.968 31.0534C104.914 29.0814 106.504 28.0789 107.641 28.0789C108.538 28.0789 109.285 28.5188 109.54 29.1592L104.968 31.0534ZM99.4093 36.0001H101.656V21.0016H99.4093V36.0001ZM95.7192 27.241H95.6382C95.1312 26.6395 94.1682 26.0948 92.9381 26.0948C90.3851 26.0948 88.033 28.3362 88.033 31.215C88.033 34.0819 90.3731 36.2963 92.9381 36.2963C94.1532 36.2963 95.1312 35.7487 95.6382 35.1352H95.7192V35.8684C95.7192 37.8165 94.6752 38.8669 92.9921 38.8669C91.6151 38.8669 90.7601 37.8794 90.4121 37.0534L88.4591 37.8674C89.0201 39.214 90.5171 40.8809 92.9891 40.8809C95.6232 40.8809 97.8552 39.3337 97.8552 35.5602V26.4001H95.7312V27.241C95.7342 27.241 95.7192 27.241 95.7192 27.241ZM93.1391 34.2943C91.5881 34.2943 90.2921 33.0016 90.2921 31.215C90.2921 29.4135 91.5881 28.1088 93.1391 28.1088C94.6752 28.1088 95.8662 29.4285 95.8662 31.215C95.8812 33.0016 94.6782 34.2943 93.1391 34.2943ZM122.468 21.0016H117.095V36.0001H119.342V30.3203H122.471C124.958 30.3203 127.403 28.5218 127.403 25.6669C127.403 22.812 124.967 21.0016 122.468 21.0016ZM122.534 28.2255H119.339V23.0784H122.534C124.217 23.0784 125.168 24.4639 125.168 25.6519C125.168 26.828 124.205 28.2255 122.534 28.2255ZM136.409 26.0799C134.777 26.0799 133.094 26.8011 132.398 28.3721L134.39 29.1981C134.819 28.3721 135.605 28.0908 136.436 28.0908C137.6 28.0908 138.776 28.7851 138.803 30.024V30.1826C138.401 29.9552 137.519 29.608 136.463 29.608C134.312 29.608 132.131 30.7811 132.131 32.9806C132.131 34.9946 133.895 36.2873 135.86 36.2873C137.369 36.2873 138.2 35.608 138.719 34.821H138.8V35.9821H140.966V30.2365C140.966 27.5612 138.974 26.0799 136.409 26.0799ZM136.127 34.2943C135.392 34.2943 134.363 33.9352 134.363 33.0135C134.363 31.8524 135.647 31.4125 136.742 31.4125C137.732 31.4125 138.2 31.625 138.788 31.9183C138.626 33.2649 137.486 34.2824 136.127 34.2943ZM148.868 26.4001L146.288 32.9058H146.207L143.534 26.4001H141.116L145.127 35.4943L142.841 40.5487H145.181L151.352 26.4001H148.868ZM128.642 36.0001H130.889V21.0016H128.642V36.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5519 9.04027C12.2039 9.41434 12.0029 9.98591 12.0029 10.734V37.2687C12.0029 38.0168 12.2039 38.5884 12.5639 38.9475L12.6569 39.0283L27.5612 24.1615V23.8293L12.6449 8.95947L12.5519 9.04027Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5199 29.1323L27.5488 24.1737V23.8265L32.5199 18.8679L32.6279 18.9338L38.508 22.2674C40.1911 23.2131 40.1911 24.7751 38.508 25.7328L32.6279 29.0664L32.5199 29.1323Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6291 29.0663L27.55 24L12.5527 38.9596C13.1017 39.5461 14.0228 39.612 15.0518 39.0404L32.6291 29.0663Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6291 18.9337L15.0518 8.97458C14.0228 8.38805 13.0987 8.46884 12.5527 9.05538L27.55 24L32.6291 18.9337Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5198 28.9587L15.0625 38.852C14.0875 39.4116 13.2175 39.3727 12.6565 38.864L12.5635 38.9568L12.6565 39.0376C13.2175 39.5433 14.0875 39.5852 15.0625 39.0256L32.6398 29.0665L32.5198 28.9587Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.509 25.5591L32.5059 28.9586L32.6139 29.0663L38.494 25.7327C39.337 25.2539 39.751 24.6254 39.751 24C39.7 24.5746 39.271 25.1192 38.509 25.5591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.051 9.148L38.5084 22.4408C39.2704 22.8687 39.6994 23.4283 39.7654 23.9999C39.7654 23.3744 39.3514 22.746 38.5084 22.2672L15.051 8.97444C13.368 8.01384 12.0029 8.81583 12.0029 10.734V10.9076C12.0029 8.98641 13.368 8.19937 15.051 9.148Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.2243,
    y1: 10.4478,
    x2: 2.35824,
    y2: 16.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.7029,
    y1: 24.0001,
    x2: 11.5935,
    y2: 24.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.8673,
    y1: 26.7568,
    x2: 10.7725,
    y2: 58.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.77626,
    y1: 0.214567,
    x2: 17.2952,
    y2: 14.6041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.077,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.1e26aace1d90b921cfc7ea09d5b8affa.svg";
export { ForwardRef as ReactComponent };